const ADMIN_STORAGE_KEYS = ['admin_user', 'admin_token', 'admin_refreshToken']

export function clearAdminSession() {
  ADMIN_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
}

export function isAdminTokenExpired(token) {
  if (!token) return true

  try {
    const payload = token.split('.')[1]
    if (!payload) return false
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(atob(normalized))
    return typeof decoded.exp === 'number' && decoded.exp * 1000 <= Date.now()
  } catch {
    // Let the API validate malformed or non-JWT tokens.
    return false
  }
}

export function redirectToAdminLogin() {
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`
  clearAdminSession()

  if (window.location.pathname === '/admin/login') return

  const params = new URLSearchParams({
    reason: 'session-expired',
    redirect: currentPath,
  })
  window.location.replace(`/admin/login?${params.toString()}`)
}
